import { Dispatch } from 'app/types/actions';
import { IGetState, TBoardId } from 'app/types/types';
import { getBoardCards } from 'app/store/model/selectors/getBoardCards';
import { getCardChecklists } from 'app/store/model/checklists/checklists/selectors/getCardChecklists';
import { checklistsLoad } from '../../../rest/effects/card/checklist/checklistsLoad';

export const getBoardFirstDate = (
    dispatch: Dispatch,
    getState: IGetState,
    boardId: TBoardId
): Promise<number> => {
    let firstDate = 0;
    return dispatch(checklistsLoad(boardId)).then(() => {
        getBoardCards(getState(), boardId)
            .forEach(card => {
                let oldestDate = card.startDate || card.dueDate;

                const checklists = getCardChecklists(getState(), card.id);
                for (let checklistId in checklists) {
                    const checklist = checklists[checklistId];
                    if (checklist && checklist.checkItems) {
                        for (let checkItemId in checklist.checkItems) {
                            const { startDate, dueDate } = checklist.checkItems[checkItemId];
                            if (startDate && startDate < oldestDate) {
                                oldestDate = startDate;
                            }
                            if (dueDate && dueDate < oldestDate) {
                                oldestDate = dueDate;
                            }
                        }
                    }
                }

                if (
                    oldestDate &&
                    (!firstDate || firstDate > oldestDate)
                ) {
                    firstDate = oldestDate;
                }
            });
        return firstDate;
    }).catch(() => {
        return firstDate;
    });
}
